var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item != null)?_c('a',{staticClass:"curriculum_card_a",attrs:{"href":"javascript:void(null);"}},[_c('div',{staticClass:"curriculum_card_outer"},[_c('div',{staticClass:"curriculum_card_title"},[_vm._v(_vm._s(_vm.itemTitle))]),_vm._v(" "),_c('div',{staticClass:"curriculum_card_desc"},[_vm._v(_vm._s(_vm.itemDesc))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4372adf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeCurriculumCard.vue
// module id = null
// module chunks = 